import { examInfo } from './type'

const info: examInfo = {
  examGroupKey: '51220061',
  type: 'WEB',
  title: '体験版　小学館思考力テスト',
  semiTitle: '小学館思考力テスト',
  signInMessage: '「体験版　小学館思考力テスト」',
  page: 1,
  howToApproach: 'プリンターでA４サイズで出力して、テストに取り組む',
  hasAdviceSheet: false,
  timeRequiredForReturn: 2,
  noteOnRegistration: 'こちらへのご登録が、名探偵コナンゼミへの入会登録となることはありませんが、各種ご案内をする場合があります。',
  showIsKaiin: true,
  downloadLink: 'https://conan-zemi.shopro.co.jp/tsushin/test/#taiken-shiko',
  endTo: '2022/12/31(土)',
  registEndTo: '2022/8/2',
  bannerLink: 'https://conan-zemi.shopro.co.jp/tsushin/?utm_source=LP_sho1_test&utm_medium=referral&utm_campaign=sho1_test_top&utm_content=sho1LP_2209',
  enqueteStart: '2022/06/13 13:00',
  enqueteEnd: '2022/10/31(月) 23:59',
  enqueteUrl: 'https://questant.jp/q/5CF9SB1W',
  qrFaqId: 6,
  requireInputAddress: false,
}

export default info;
